import { centroide3857, urlGeoportal} from './configuracion';

const controlIrGeoportal = document.getElementById('controlIrGeoportal'),
controlVistaGeneral = document.getElementById('controlVistaGeneral'),
//controlInicio= document.getElementById('controlInicio'),
controlMas = document.getElementById('controlMas'),
controlMenos = document.getElementById('controlMenos');

controlIrGeoportal.addEventListener('click', function () {
    window.location.href = urlGeoportal;  
});

controlVistaGeneral.addEventListener('click', function () {
    global.vista.setCenter(centroide3857);
    if(global.mapa.getSize()[0] > 1296) global.vista.setZoom(11);
    else global.vista.setZoom(10);  
});

//controlInicio.addEventListener('click', function () {});

controlMas.addEventListener('click', function() {
    let zoomActual = global.vista.getZoom();
    zoomActual= zoomActual + 1;
    global.vista.setZoom(zoomActual); 
});

controlMenos.addEventListener('click', function() {
    let zoomActual = global.vista.getZoom();
    zoomActual= zoomActual - 1;
    global.vista.setZoom(zoomActual); 
});